import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityPaisesDocumentoState,
  entityPaisesDocumentoAdapter
} from './paises-documento.state';

const { selectEntities, selectAll } =
  entityPaisesDocumentoAdapter.getSelectors();

export const getError = (state: EntityPaisesDocumentoState): any => state.error;

export const getIsLoading = (state: EntityPaisesDocumentoState): boolean =>
  state.isLoading;

export const selectPaisesDocumentoState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.paisesDocumento
);

export const selectAllPaisesDocumento = createSelector(
  selectPaisesDocumentoState,
  selectAll
);
export const selectEntitiesPaisesDocumento = createSelector(
  selectPaisesDocumentoState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectPaisesDocumentoError = createSelector(
  selectPaisesDocumentoState,
  getError
);

// MemoizedSelector<object,any>
export const selectPaisesDocumentoIsLoading = createSelector(
  selectPaisesDocumentoState,
  getIsLoading
);
